var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountsButtomMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65537e-07 12.501C-0.00202735 5.60923 5.45003 -0.00312188 12.1442 1.30286e-06C18.89 0.00312448 24.3411 5.59257 24.3421 12.5052C24.3421 19.446 18.8941 25.0031 12.0925 25C5.43685 24.9958 0.00202848 19.3783 5.65537e-07 12.501ZM3.46875 18.5486C5.91239 16.0948 8.80724 14.8018 12.1939 14.8049C15.5764 14.808 18.4642 16.1125 20.8774 18.5371C23.4813 14.8715 23.5806 8.77093 19.5086 4.72329C15.5075 0.746441 9.23209 0.638171 5.11339 4.46198C0.942982 8.33472 0.690506 14.5207 3.46875 18.5486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1878 13.3339C9.49777 13.3339 7.31066 11.0977 7.30762 8.34409C7.30458 5.58424 9.48053 3.33868 12.1655 3.33347C14.8707 3.32827 17.0548 5.58424 17.0447 8.37428C17.0355 11.0967 14.8444 13.3339 12.1868 13.3328L12.1878 13.3339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3421,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountsButtomMenu);
export default __webpack_public_path__ + "static/media/my_accounts_buttom_menu.223961f03413517a957b1f2a1cc293f7.svg";
export { ForwardRef as ReactComponent };